/**
 * 权限模块 - 兼容旧版本API
 * 现在主要功能已迁移到dynamicRoute模块
 * 此模块保留用于向后兼容
 */

const state = {
  routes: [],
  addRoutes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    state.addRoutes = routes
    state.routes = routes
  }
}

const actions = {
  /**
   * 生成路由 - 兼容旧版本API
   * 实际功能已迁移到dynamicRoute模块
   */
  generateRoutes({ commit, dispatch }, obj) {
    return new Promise(async (resolve) => {
      try {
        const systemType = obj.type || 'oa'
        console.warn('permission/generateRoutes已废弃，请使用dynamicRoute/generateRoutes')
        
        // 调用新的动态路由模块
        const routes = await dispatch('dynamicRoute/generateRoutes', systemType, { root: true })
        
        commit('SET_ROUTES', routes)
        resolve(routes)
      } catch (error) {
        console.error('生成路由失败:', error)
        resolve([])
      }
    })
  }
}

const getters = {
  routes: state => state.routes,
  addRoutes: state => state.addRoutes
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
